import Enum from '@/modules/core/app/models/abstracts/Enum';

export class ClientReportingStatus extends Enum {
  static PENDING_MAPPING = 'pending_mapping';

  static ACTIVE = 'active';

  static HOLD = 'hold';

  static TERMINATED = 'terminated';
}

export const ClientRoute = {
  CLIENTS: 'clients',
};

export const ClientPathName = {
  CLIENTS: 'clients',
  CLIENTFORM_NEW: 'clientform:new',
  CLIENTFORM: 'clientform',
  CLIENTS_TAB: 'clients.tabname',
  CLIENTOVERVIEW: 'clientoverview',
};

export const ReportingStatusField = 'reporting_status';
export const IOToolStatusField = 'iotool_status';

export const ClientFormTabs = {
  SETTINGS: 'settings',
  INFO: 'info',
  AI_CONTEXT: 'ai_context',
  BRANDING: 'branding',
  USERS: 'users',
  CALCULATION: 'calculation',
};

export const ClientFields = {
  ID: 'id',
  NAME: 'name',
};

export const DemoClientCompanyName = 'Demo Advertiser Client';

// Signals the client form page's Cancel so embedded editors (AdfloClientForm) reset their state.
export const ClientFormCancelledEvent = 'client-form:cancelled';

// Signals a completed client form page save so embedded editors re-sync from the server (backend
// side effects: defaults applied on first association, calculations, projections).
export const ClientFormSavedEvent = 'client-form:saved';

// Mirrors ClientForm::RESERVED_FIELD_NAMES on the backend: client form fields can never use these
// names, and values under these keys must never be mirrored into the client save payload (they would
// mutate identity / BU scoping / status machinery on the client row).
export const ReservedClientFieldNames = [
  'id',
  'entity_item_id',
  'cluster_id',
  'status',
  'status_id',
  'reporting_status',
  'iotool_status',
  'created_at',
  'updated_at',
  'creation_time',
  'created_by_user',
  'client_group_ids',
  'product_ids',
  'activate_tapleads',
  'allow_all_business_units_for_booking_orders',
];

// Payload keys owned by the client page's native inputs (Settings/Info tabs). A pass-through form
// field with one of these names is hidden from the embedded FormPreview (the native input is the
// single edit surface) and its key is never mirrored from the preview into the save payload.
export const NativeClientFieldNames = [
  'company_name',
  'first_name',
  'last_name',
  'email',
  'phone',
  'fax',
  'website',
  'address_1',
  'address_2',
  'city',
  'state',
  'zip',
  'crm_id',
  'billing_id',
  'additional_details_1',
  'additional_details_2',
  'additional_details_3',
  'account_manager_user_id',
  'naics_code',
  'proposal_tool_id',
  'client_category_id',
  'default_reporting_profile_id',
  'report_language',
  'country',
  'currency',
  'audience_version',
  'is_partner',
  'logo_file',
  'iotool_fb_ads_account_id',
  'iotool_fb_ads_page_id',
];
